import { router } from './router'
import { usePermissionStore } from '@/stores/modules/permission'
import { useAccountStore } from '@/stores/modules/account'
// import { useSocketMsg } from '@/stores/modules/socketMsg'
import { useNavHistory } from '@/stores/modules/routerNav'
import { getToken, removeToken } from '@/utils/auth'
import type { RoleMenuType } from '@/types/menu'
import { filterCurrentRoute } from '@/utils/util'
import NProgress from 'nprogress' // progress bar
import { computed, unref } from 'vue'
import { useGlobalFlow } from '@/stores/modules/globalFlow'
import { useOrgInfoStore } from './stores/modules/orgInfo'
import useTracker from '@/hooks/useTracker'
import { getDetailsMenu } from '@/hooks/useTracker/utils'

export const whiteList: string[] = [
  '/login',
  '/h5Download',
  '/iosDownload',
  '/systemRank',
  '/receiptDownloadLink'
]

export const detailPaths = [
  '/customerDetail',
  '/clueDetail',
  '/clueHighSeasDetail',
  '/clueRecycleDetail',
  '/highSeaDetail',
  '/recycleBinDetail'
]
router.beforeEach((to, from, next) => {
  const usePermission = usePermissionStore()
  const accountStore = useAccountStore()
  const navHistory = useNavHistory()
  const { showLoginVisible } = useOrgInfoStore()
  // 冻结弹窗重新刷页面直接退出到登录
  const loginTimout = localStorage.getItem('loginTimout')
  // const socketMsg = useSocketMsg()
  if (to.name === 'Login') showLoginVisible(false)
  if (loginTimout) {
    showLoginVisible(false)
    accountStore.logout()
    removeToken()
    localStorage.removeItem('loginTimout')
  }
  to.meta.from = from.name || ''
  const status = computed(() => {
    return usePermission.status
  })
  if (getToken()) {
    // 已经登录
    if (whiteList.includes(to.path)) {
      next()
      NProgress.done()
    } else {
      if (status.value) {
        // 解决系统消息跳转到预定义页面没有拼接menuId的问题
        if (usePermission.getPredefineAppId(to.path)) {
          const urlQuery = new URLSearchParams(to.query as Recordable).toString()
          next(
            `${to.path}/${usePermission.getPredefineAppId(to.path)}` +
              (urlQuery ? '?' + urlQuery : '')
          )
        } else {
          next()
        }
      } else {
        accountStore
          .getUserInfoAndMenus()
          .then(() => {
            navHistory.setActive(to.path)
            next()
          })
          .catch(() => {
            // 用户信息/菜单拉取失败时必须结束守卫，否则路由会一直卡住
            accountStore.logout(true, false)
            next('/login')
            NProgress.done()
          })
        // accountStore.getUser()
        // usePermission.getSystemList().then(() => {
        //   navHistory.setActive(to.path)
        //   next()
        // })
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
      NProgress.done() // finish progress bar
    } else {
      next('/login')
      NProgress.done() // finish progress bar
    }
  }
})
router.afterEach(to => {
  const permissionStore = usePermissionStore()
  const navHistory = useNavHistory()
  let menu: any = filterCurrentRoute(unref(permissionStore.allMenuList) as any, unref(to.path))
  // 路由切换后需要刷新一下menuList和systemCode
  if (menu?.systemCode) permissionStore.changeSystem(menu.systemCode, to.path, false)
  // 如果跳转到客户详情、线索详情、公海详情、线索公海、线索回收、回收站将systemCode重置为CRM，否则客户详情中移交、还原、分配调取的组织架构器权限有问题
  if (detailPaths.includes(to.path)) {
    permissionStore.changeSystem('CRM', to.path, false)
  }
  !whiteList.includes(to.path) &&
    navHistory.addHistory({
      name: to.meta.title as string,
      path: to.path,
      closeAble: false,
      componentName: to.name as string,
      systemCode: detailPaths.includes(to.path) ? 'CRM' : permissionStore.currentSys,
      fullPath: to.fullPath
    })
  if (detailPaths.includes(to.path)) menu = getDetailsMenu(to.path)
  trackAction(menu)
})

// 此处去获取数据或执行任何其他操作
router.beforeResolve(to => {
  const globalFlow = useGlobalFlow()
  const permissionStore = usePermissionStore()
  permissionStore.setHeaderMenuId('') // 这里清空一下特殊配置的menuId
  permissionStore.setHeaderTableCode('') // 这里清空一下特殊配置的menuId
  const menu: any = filterCurrentRoute(unref(permissionStore.allMenuList) as any, unref(to.path)) // fullPath  path
  permissionStore.setCurrentMenu(menu)
  // 关闭一下全局弹框
  globalFlow.setVisible(false, 'business')
})

export function trackAction(menu: RoleMenuType) {
  const { tracker } = useTracker()
  const permissionStore = usePermissionStore()
  // 页面浏览时长 上报
  if (tracker.leaveRouteInfo) {
    tracker.trackPageLeave({
      ...tracker.leaveRouteInfo
    })
  }

  if (whiteList.includes(menu.path)) return
  // 不是表单页的页面
  const noTableList: string[] = [
    '/workBench',
    '/workbenchConfiguration',
    '/callCenterConfig/callSetup',
    '/callCenterConfig/openCallCenter',
    '/callCenterConfig/callSetup',
    '/callCenterConfig/blacklistValidate',
    '/trafficAlliance/trafficProduct',
    '/ryhPlatform/productManage',
    '/accountConfig',
    '/systemConfig/menuConfig',
    '/workerManage',
    '/systemManage/permissionManage',
    '/customManageConfig/systemGlobalConfig',
    '/customManageConfig/followRecordConfig',
    '/customManageConfig/staffPrivateConfig',
    '/appStore',
    '/loanManagementConfiguration/otherConfig',
    '/rjtManageConfig/serviceConfiguration',
    '/customerDetail',
    '/clueDetail',
    '/clueHighSeasDetail',
    '/clueRecycleDetail',
    '/highSeaDetail',
    '/recycleBinDetail'
  ]
  // 页面浏览上报
  tracker.trackPageView({
    ...menu,
    noTable: noTableList.includes(menu.path),
    systemCode: detailPaths.includes(menu.path) ? 'CRM' : permissionStore.currentSys
  })
}
